var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Inject, State, Mutation } from 'vue-class-state';
import { jsonp } from '../../common/http';
import { bindVisibilityChange } from '../../common/utils';
/**
 * 各个页面共享的数据
 */
export class CommonState {
    constructor() {
        /**
           * 频道模块数据
           */
        this.moduleList = [];
    }
    bindGlobalEvent() {
        const loginchange = () => window.location.reload();
        txv.login.addLoginCallback(loginchange);
        txv.login.addLogoutCallback(loginchange);
        bindVisibilityChange(() => {
            if (!txv.login.isLogin()) {
                loginchange();
            }
        });
    }
    /**
       * 接口对接 minglinlu
       */
    getModuleListData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.moduleList.length)
                return;
            try {
                const res = yield jsonp('//access.video.qq.com/pc_client/get_module_data?vappid=50662744&vsecret=64b037e091deae75d3840dbc5d565c58abe9ea733743bbaf&strParam=&strChannelName=vsite_person_info&iPlatform=4&iModuleCount=3&strVersion=1&vplatform=18');
                if (res.ret === 0 && res.data.iErrCode === 0 && Array.isArray(res.data.vecModuleList)) {
                    Mutation.commit(this, () => {
                        this.moduleList = res.data.vecModuleList;
                    });
                }
                else {
                    // todo
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
}
__decorate([
    State
], CommonState.prototype, "moduleList", void 0);
export const ICommonState = Inject('common');
// http://access.video.qq.com/pc_client/get_module_data?vappid=50662744&vsecret=64b037e091deae75d3840dbc5d565c58abe9ea733743bbaf&callback=func&strParam=&strChannelName=persion_info&iPlatform=2&iModuleCount=3&strVersion=99999999&vplatform=18
